<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="전체 전화 상담/주문 내역"
      desc="파트너에게 전화를 통해 상담/주문한 전체 내역입니다. 파트너가 통화내용을 기록하고 관리할 수 있습니다."
    ></admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="2000"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="call_detail" slot-scope="props">
        <button class="button"
                @click.stop.prevent="clickCall(props.item,'update')">상세보기</button>
      </div>

    </admin-table>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  import moment from 'moment'
  import LpSortDropDown from '../../module/common/LpSortDropDown'
  import LpInputText from '../../module/common/LpInputText'
  import LpRadio from '../../module/common/LpRadio'
  import LpModal from '../../module/common/LpModal.vue'


  export default {
    name: 'CallOrderNew',
    mixins: [
      ListMixin
    ],

    components: {
      LpSortDropDown, LpInputText, LpRadio,
      LpModal
    },
    created() {
      this.init();
    },
    data () {
      return {
        nowTime: '',
        nowOpened: '',
        searchType: [
          { label: '전체', value: 'all' },
          { label: '이름', value: 'name' },
          { label: '상담내용', value: 'content' },
          { label: '연락처', value: 'phone' },
        ],
        memberArr: [
          { label: '전체', value: '' },
          { label: '회원', value: 'false' },
          { label: '비회원', value: 'true' }
        ],
        /* // 필터링 데이터
         filtered: {
           date: {
             min: '',
             max: ''
           },
           memberState: '전체',
           reserveState: '전체',
           state: 'all',
           search_type: 'all',
           search_keyword: '',
           page_num: 1,
           page_length: 10,
           // order_field: {
           //   value: 'asc',
           //   item: 'ests'
           // }
         },*/
        filtered: {
          min_price:"",
          max_price:"",
          start: "",
          end: "",
          cat1: "",
          cat2: "",
          cat3: "",
          sido: "",
          sigungu: "",
          dong: "",
          ordering: "",
          is_guest: "",
          search_type: 'all',
          search_keyword: '',
          page_num: 1,
          page_length: 10
        },
        tableItems:[],
        allCount: 0,
        filteredCount: 0,
        pageCount: 0,
        pageLengthList : [
          {
            label: '5개씩 보기',
            value: 5
          },
          {
            label: '10개씩 보기',
            value: 10
          },
          {
            label: '20개씩 보기',
            value: 20
          },
          {
            label: '30개씩 보기',
            value: 30
          }
        ],
        modalCall: 0
      }
    },
    watch: {
      'filtered.ordering'(){
        this.getData();
      },
      'filtered.is_guest'(){
        this.getData();
      }
    },
    methods: {
      init () {
        this.initializing('call_order_new', 'inquiry/call');
        this.nowTime = moment().format('YY-MM-DD');
        this.filtered.start =  moment().format('YYYY-MM-DD');
        //this.getData();
      },
      getDataFromServer() {
        this.getData();
      },
      clickCall(item, kind) {
        if(kind === 'update') {
          this.$router.push(this.getPath('cs/call/create?id='+item.id + '&types=callorder'));
        }
      },
      delCall() {
        this.$axios.post('del_call?id='+this.modalCall)
          .then(res => {
            if(res.data.result==='ok') {
              this.$refs.deleteModal.close();
              this.toast('문의 내용이 삭제되었습니다.');
              this.getData();
            }
          });
      },
      selectMemberState(state) {
        this.filtered.memberState = state;
      },
      selPageLen(length) {
        this.filtered.page_length = length;
        this.filtered.page_num = 1;
        this.getData();
      },
      selSearchType(type) {
        this.filtered.search_type = type;
      },
      clickSearch() {
        this.filtered.page_num = 1;
        this.getData();
      },
      selDateMin(date) {
        this.filtered.start = date;
        this.getData();
      },
      selDateMax(date) {
        this.filtered.end = date;
        this.getData();
      },
      getData() {
        this.$axios.get(this.getUrl('inquiry/call'),{
          params:this.filtered
        })
          .then(res => {
              if(res.status===200) {
                this.tableItems = res.data.data;
                this.filtered.page_length = res.data.page_length;
                this.filtered.cur_page = res.data.cur_page;
                this.pageCount = res.data.total_page;
                this.allCount = res.data.total_count;
                this.filteredCount = res.data.count;
              }
            }
          );
      },
      prevPage() {
        if(this.filtered.page_num > 1) {
          this.filtered.page_num -= 1;
          this.getData();
        }
      },
      nextPage() {
        if(this.filtered.page_num < this.pageCount) {
          this.filtered.page_num += 1;
          this.getData();
        }
      },
      changePage(num) {
        this.filtered.page_num = num;
        this.getData();
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  //@import '~assets/css/lp_main'

  .tr-whole-border th
    padding 12px 6px
  .many-field-tr td
    padding 6px

  .progress-btn
    border-radius 3px
    display inline-block
    width 84px
    padding 6px 0
    margin 2px
    font-weight bold
    font-size .8rem
  .btn-confirm-new-req
    background-color #ffb100
    color #fff
  .btn-stand-by-ests
    color #064160
    font-weight bold
  .btn-write-sheet
    background-color $primary
    color #fff

  .bid-state
    margin 2px 0
    color #fff
    border-radius 3px
    display inline-block
    width 76px
    padding 4px

  .bid-state-ing
    background-color #1c7cd5
  .bid-state-ok
    background-color #5cb85c
  .bid-state-no
    background-color #f0ad4e
</style>
